<template>
      <div class="medicalAlertCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'medicalAlert', params: {} }">
          Medical Alert
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'medicalAlertCreate', params: {} }">
            Create Medical Alert
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Medical Alert</v-card-title>
          <v-card-text>
            <medicalAlert-form></medicalAlert-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import MedicalAlertForm from './MedicalAlertForm.vue';

    export default {
      name: 'medicalAlert',
      components: {
        MedicalAlertForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    